export const ALL_PRODUCTS_FILTER = 'All Products';

const FILTER_ALIASES = {
  map: 'Maps',
  maps: 'Maps',
  script: 'Scripts',
  scripts: 'Scripts',
  ped: 'Peds',
  peds: 'Peds',
  mlo: 'MLO',
  vehicle: 'Vehicles',
  vehicles: 'Vehicles'
};

const normalizeFilterValue = (value) => String(value || '').trim().toLowerCase();

export const buildProductsPath = (filter = ALL_PRODUCTS_FILTER) => {
  if (!filter || filter === ALL_PRODUCTS_FILTER) {
    return '/products';
  }

  return `/products?filter=${encodeURIComponent(filter)}`;
};

export const resolveProductsFilter = (rawFilter, availableFilters = []) => {
  if (!rawFilter) {
    return null;
  }

  const normalizedFilter = normalizeFilterValue(rawFilter);
  const directMatch = availableFilters.find(
    (filter) => normalizeFilterValue(filter) === normalizedFilter
  );

  if (directMatch) {
    return directMatch;
  }

  const aliasedFilter = FILTER_ALIASES[normalizedFilter];
  if (!aliasedFilter) {
    return null;
  }

  return (
    availableFilters.find(
      (filter) => normalizeFilterValue(filter) === normalizeFilterValue(aliasedFilter)
    ) || null
  );
};
